module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/nusajaya-2021.jpg?v=c6a5dc75";